module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMin),
      expression: "showMin"
    }],
    staticClass: "top-tips"
  }, [_vm._v(" 请尽快完成支付")]), _vm._v(" "), (_vm.busiType != '5') ? _c('section', {
    staticClass: "doctor-info row"
  }, [_c('div', {
    staticClass: "head pay-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "f-large pay-tips"
  }, [_c('span', {
    staticClass: "f-strong"
  }, [_vm._v("预约成功，请马上支付！")]), _vm._v(" ")]), _vm._v(" "), _c('p', {
    staticClass: "f-middle f-minor"
  }, [_vm._v("订单号：" + _vm._s(_vm.orderId))]), _vm._v(" "), _c('p', {
    staticClass: "pay-type f-strongest f-largest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.totalFee)))])])]) : _vm._e(), _vm._v(" "), (_vm.busiType === '5') ? _c('section', [_c('dl', {
    staticClass: "field",
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "f-strong f-middle"
  }, [_vm._v("订单号：" + _vm._s(_vm.orderId))]), _vm._v(" "), _c('dd', {
    staticClass: "right-item f-strongest f-largest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.totalFee)))])])]) : _vm._e(), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "panel"
  }, [_vm._v("请选择支付方式")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.payTypes), function(payType) {
    return _c('li', {
      staticClass: "icon-row arr-item",
      on: {
        "click": function($event) {
          return _vm.selectPayType(payType)
        }
      }
    }, [_c('div', {
      staticClass: "col pay-icon",
      class: {
        weixin: payType.id == '4', zhifubao: payType.id == '5', zizhu: payType.id == '8', union: payType.id == '7', social: payType.id == '10'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "desc col"
    }, [_c('div', {
      staticClass: "gwi-size-normal pay-title"
    }, [_vm._v(_vm._s(payType.name))]), _vm._v(" "), _c('div', {
      staticClass: "gwi-size-small"
    }, [(payType.id == '4') ? _c('span', {
      staticClass: "f-minor f-small"
    }) : _vm._e(), _vm._v(" "), (payType.id == '5') ? _c('span', {
      staticClass: "f-minor f-small"
    }, [_vm._v("需要安装支付宝APP客户端")]) : _vm._e(), _vm._v(" "), (payType.id == '8') ? _c('span', {
      staticClass: "f-minor f-small"
    }, [_vm._v("自助机刷银行卡和社保卡")]) : _vm._e()])])])
  }), 0)])]), _vm._v(" "), _c('half-window', {
    attrs: {
      "data-list": _vm.voucherList
    },
    model: {
      value: (_vm.showWindow),
      callback: function($$v) {
        _vm.showWindow = $$v
      },
      expression: "showWindow"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "f-strong"
  }, [_vm._v("选择卡")])]), _vm._v(" "), _c('ul', {
    staticClass: "list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.voucherList), function(item) {
    return _c('li', {
      staticClass: "list-item",
      class: 'arr-item-blue',
      on: {
        "click": function($event) {
          return _vm.selectPayCard(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.holderName) + "/" + _vm._s(_vm._f("dotted")(item.bankCardNo)))])])
  }), 0)]), _vm._v(" "), _c('confirm', {
    attrs: {
      "text": "该微信暂未绑定医保卡，请点击确定按钮绑卡！"
    },
    on: {
      "on-sure": _vm.goBindUrl
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a6f6f0a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pay/Pay.vue
// module id = 861
// module chunks = 0